module.exports = __webpack_public_path__ + "static/actionlist-actionbar-do-3f7a63cc1c129dea908a8da2bfd771f9.png";